export default class MessageHandler{
    match(signal){
        return false;
    }

    processMessage(data){

    }
}


// WEBPACK FOOTER //
// ./src/fscommon/websocket/handler/messageHandler.js